import { Box, Stack } from "@mui/material";
import { BodyTextM, cs, HeadingS } from "@repo/ui";
import { useFormikContext } from "formik";
import { type FC, useState } from "react";
import Trigger from "../Link/Trigger";
import TriggerButton from "../Link/TriggerButton";
import SimpleDrawer from "./SimpleDrawer";

interface ConfirmDeleteProps {
	handleConfirmDelete: () => void;
}

const ConfirmDelete: FC<ConfirmDeleteProps> = ({ handleConfirmDelete }) => {
	const { isSubmitting } = useFormikContext();
	const [isOpen, setIsOpen] = useState(false);
	return (
		<>
			<Trigger
				onClick={() => {
					setIsOpen(true);
				}}
			>
				{cs.global.delete}
			</Trigger>
			<SimpleDrawer
				onClose={() => setIsOpen(false)}
				onOpen={() => setIsOpen(true)}
				open={isOpen}
			>
				<Stack spacing={6}>
					<Box>
						<HeadingS>Upozornění</HeadingS>
						<BodyTextM>
							Tímto krokem trvale vymažete zvolenou osobu ze seznamu. Přejete-li
							si pokračovat, klikněte na tlačítko Odstranit.
						</BodyTextM>
					</Box>
					<Stack
						direction={{ xs: "column", md: "row" }}
						spacing={{ xs: 0, md: 4 }}
						justifyContent="space-between"
					>
						<TriggerButton
							variant="text"
							disabled={isSubmitting}
							onClick={() => {
								setIsOpen(false);
							}}
						>
							{cs.global.cancel}
						</TriggerButton>
						<TriggerButton
							disabled={isSubmitting}
							onClick={() => {
								handleConfirmDelete();
								setIsOpen(false);
							}}
						>
							{cs.global.delete}
						</TriggerButton>
					</Stack>
				</Stack>
			</SimpleDrawer>
		</>
	);
};

export default ConfirmDelete;
